export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9746.26b65d08.jpg";